// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupInfoCard__container-afaba9 {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.PopupInfoCard__info-e26a64 {
  overflow: hidden;
  max-width: 330px;
  margin-inline-start: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}

.PopupInfoCard__title-container-a7b8dd {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.PopupInfoCard__title-eea2e3 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
  display: flex;
  align-items: center;
  flex-direction: row;
}

.PopupInfoCard__subtitle-ee0c5a {
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.PopupInfoCard__round-0-dcefbf {
  .PopupInfoCard__title-eea2e3 {
    font: var(--font-subtitle-2);
    letter-spacing: var(--font-spacing-subtitle);
  }
  .PopupInfoCard__subtitle-ee0c5a {
    font: var(--font-subtitle-4);
    letter-spacing: var(--font-spacing-subtitle);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PopupInfoCard/style.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;EACE;IACE,4BAAA;IACA,4CAAA;EACF;EAEA;IACE,4BAAA;IACA,4CAAA;EAAF;AACF","sourcesContent":[".container {\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.info {\n  overflow: hidden;\n  max-width: 330px;\n  margin-inline-start: 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: left;\n}\n\n.title-container {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n\n.subtitle {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.round-0 {\n  .title {\n    font: var(--font-subtitle-2);\n    letter-spacing: var(--font-spacing-subtitle);\n  }\n\n  .subtitle {\n    font: var(--font-subtitle-4);\n    letter-spacing: var(--font-spacing-subtitle);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PopupInfoCard__container-afaba9`,
	"info": `PopupInfoCard__info-e26a64`,
	"title-container": `PopupInfoCard__title-container-a7b8dd`,
	"titleContainer": `PopupInfoCard__title-container-a7b8dd`,
	"title": `PopupInfoCard__title-eea2e3`,
	"subtitle": `PopupInfoCard__subtitle-ee0c5a`,
	"round-0": `PopupInfoCard__round-0-dcefbf`,
	"round0": `PopupInfoCard__round-0-dcefbf`
};
module.exports = ___CSS_LOADER_EXPORT___;
